<style>
#prwCard .v--modal-box.v--modal {
  min-height: 500px !important;
  min-width: 680px !important;
}
#prwCard #attr__wrapper .layout:not(#geometry-panel) {
  margin-top: 20px;
}
#prwCard .v-tabs__div:not(:last-child) {
  padding-right: 10px;
  background-image: linear-gradient(
      to bottom,
      rgba(42, 87, 154, 1) 0%,
      rgba(42, 87, 154, 1) 100%
    ),
    linear-gradient(
      to bottom,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    );
  background-clip: content-box, padding-box;
}
#prwCard .v-select__selection {
  font-size: 12px !important;
}
#prwCard .v-subheader {
  font-size: 14px !important;
  color: #000 !important;
  font-weight: 600 !important;
}
#prwCard .btn--card {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
#prwCard .caption--identification {
  display: inline;
  text-align: center;
  vertical-align: super;
}
.prw-card__watermeters {
  margin-top: 20px;
}
</style>

<template>
  <Modal
    modalName="prwCard"
    :title="`KARTA PUNKTU ROZBIORU WODY O ID ${oid}`"
    :buttons="['']"
    :module="module"
    @opened="loadAttachments(), loadWatermeters(), sendId()"
  >
    <div style="height:100%">
      <v-tabs
        color="#2a579a"
        dark
        centered
        grow
        active-class="tab--active"
        :hide-slider="true"
        height="35"
        style="height:100%"
      >
        <v-tab>ATRYBUTY</v-tab>
        <v-tab-item>
          <v-card
            flat
            id="attr__wrapper"
          >
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>ATRYBUTY</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.net_kind"
                  :readonly="!editing"
                  label="Rodzaj sieci"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_voivodeship"
                  :readonly="!editing"
                  label="Województwo"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_county"
                  :readonly="!editing"
                  label="Powiat"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_community"
                  :readonly="!editing"
                  label="Gmina"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_place"
                  :readonly="!editing"
                  label="Miejscowość"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_street"
                  :readonly="!editing"
                  label="Ulica"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_order"
                  :readonly="!editing"
                  label="Numer porządkowy"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.address_plot"
                  :readonly="!editing"
                  label="Numer lokalu"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.registry_exploitation"
                  :readonly="!editing"
                  label="Numer eksploatacyjny"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.location_type"
                  :readonly="!editing"
                  label="Typ lokalizacji"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.description"
                  :readonly="!editing"
                  label="Opis dodatkowy"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.acquisition"
                  :readonly="!editing"
                  label="Sposób pozyskania danych"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.source"
                  :readonly="!editing"
                  label="Źródło danych"
                ></v-text-field>
              </v-flex>
              <v-spacer />
              <v-flex xs5>
                <v-select
                  :items="statuses"
                  v-model="prwData.status"
                  label="Status"
                  :append-icon="editing ? '$vuetify.icons.dropdown' : ''"
                  :readonly="!editing"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs5>
                <v-text-field
                  v-model="prwData.inventory"
                  :readonly="!editing"
                  label="Ewidencja"
                ></v-text-field>
              </v-flex>
              <v-spacer />
            </v-layout>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <v-subheader>POWIĄZANE PRZYŁĄCZE</v-subheader>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              class="geometry-panel"
            >
              <v-flex
                xs4
                v-if="!prwData.parent_pipe"
                style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
              >
                <v-icon
                  class="table__btn--orange geometry-panel__add-btn"
                  @click="addGeometry"
                >edit</v-icon>
                <p
                  @click="addGeometry"
                  class="hover__pointer"
                >ZMIEŃ PRZYŁĄCZE</p>
              </v-flex>
              <v-flex
                xs4
                v-else
                style="border-right: 1px solid lightgrey;line-height: 50px;display:flex;"
                :class="{btnDisabled: !editing}"
              >
                <v-icon
                  :class="{btnDisabled: !editing}"
                  class="table__btn--red geometry-panel__delete-btn"
                >delete</v-icon>
                <p class="hover__pointer">ZMIEŃ PRZYŁĄCZE</p>
              </v-flex>
              <v-flex xs8>
                <v-layout
                  justify-space-between
                  id="geometry-panel"
                >
                  <p
                    v-if="prwData.parent_pipe"
                    class="msg--padding"
                  >POWIĄZANE PRZYŁĄCZE O ID {{prwData.parent_pipe}}</p>
                  <p
                    v-else
                    class="msg--padding"
                  >BRAK POWIĄZANEGO PRZYŁĄCZA</p>
                  <span v-if="prwData.parent_pipe">
                    <v-icon
                      title="Przybliż do geometrii"
                      class="geometry-panel__zoom-btn"
                      @click="zoomToGeom"
                    >zoom_in</v-icon>
                  </span>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-card>
        </v-tab-item>

        <v-tab>HISTORIA</v-tab>
        <v-tab-item>
          <v-card
            flat
            style="height:100%"
          >
            <SingleObjectHistoryTable
              :featureID="oid"
              :objectTable="objectTable"
            />
          </v-card>
        </v-tab-item>

        <v-tab>WODOMIERZE</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-expansion-panel
              class="prw-card__watermeters"
              v-if="watermeters.length > 0"
            >
              <v-expansion-panel-content
                v-for="watermeter in watermeters"
                :key="watermeter.id"
              >
                <template v-slot:header>
                  <div>WODOMIERZ: {{watermeter.properties.id}}</div>
                </template>
                <v-card>
                  <v-container>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          label="ID"
                          v-model="oid"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.billing_id"
                          label="Identyfikator w systemie billingowym"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.idwodomierz"
                          label="ID wodomierza"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.nrkartotekiwodomierz"
                          label="Numer kartoteki wodomierza"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.nrwodomierz"
                          label="Numer wodomierza"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.status"
                          label="Status"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.dataodczyt"
                          label="Data odczytu"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.odczyt"
                          label="Odczyt"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.idobiektu"
                          label="ID obiektu"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.akronimobiekt"
                          label="Akronim obiektu"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.miejscowosc"
                          label="Miejscowość"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.ulica"
                          label="Ulica"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.nrdomu"
                          label="Numer domu"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.nrlokalu"
                          label="Numer lokalu"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.wlasnoscprzylacza"
                          label="Własność przyłącza"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.srednicawodomierz"
                          label="Średnica wodomierza"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      row
                      wrap
                    >
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.datamontazwodomierz"
                          label="Data montażu wodomierza"
                        ></v-text-field>
                      </v-flex>
                      <v-spacer />
                      <v-flex xs5>
                        <v-text-field
                          v-model="watermeter.properties.datalegalnosciwodomierz"
                          label="Upływ cech legalizacji"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <span
                      class="btn--card"
                      title="Otwórz kartę obiektu"
                      @click="openWatermeter"
                    >
                      <v-icon
                        class="table__btn--blue table__btn--padding"
                        style="padding-left: 25px;"
                      >
                        note
                      </v-icon>
                      <p class="caption caption--identification">KARTA OBIEKTU</p>
                    </span>
                  </v-container>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <span v-else>Ładowanie wodomierzy w toku...</span>
          </v-card>
        </v-tab-item>

        <v-tab v-if="featureEvents != undefined && featureEvents.hasOwnProperty('events')">ZDARZENIA ({{featureEvents.events_count}})</v-tab>
        <v-tab v-else>ZDARZENIA (0)</v-tab>
        <v-tab-item>
          <v-card flat>
            <Events
              style="margin-top: 15px"
              :featureEvents="featureEvents"
              :objectType="objectType"
              :id="oid"
            />
          </v-card>
        </v-tab-item>

        <v-tab>ZAŁĄCZNIKI ({{attachmentsArr.hasOwnProperty('data') ? attachmentsArr.data.length : '0'}})</v-tab>
        <v-tab-item>
          <v-layout row>
            <!-- <v-flex
                xs12
                v-if="$can('read', 'partitions_attachments') || $can('edit', 'partitions_attachments')"
              > -->
            <v-flex xs12>
              <v-subheader class="font--primary">Powiązane załączniki</v-subheader>
              <div v-if="ifAttachments.hasOwnProperty('data') && ifAttachments.data.length > 0">
                <li
                  class="list__container--el"
                  v-for="(index, key) in attachmentsArr.data"
                  :key="key"
                >
                  <span>{{index.id}} - {{index.filename}}</span>
                  <span>
                    <v-icon
                      @click="downloadAttachment(index.id, index.filename)"
                      small
                      title="Pobierz załącznik"
                      v-if="$can('read', 'inspections_attachments') || $can('edit', 'inspections_attachments')"
                    >cloud_download</v-icon>
                    <v-icon
                      @click="deleteAttachment(index.id)"
                      small
                      title="Usuń załącznik"
                      v-if="$can('edit', 'inspections_attachments')"
                    >delete</v-icon>
                  </span>
                </li>
              </div>
              <div v-else>
                <p class="font--primary">Brak powiązanych załączników</p>
              </div>
              <AddAttachment
                ref="prwCardAttach"
                @attachmentAdded="loadAttachments()"
                @attachmentDeleted="loadAttachments()"
                @confDialogOpened="triggerDialogAttach"
                @fileAdded="updateList"
                @fileRemoved="updateListRemove"
                :id_="oid"
                :objectType="objectType"
                :objectTable="objectTable"
                :auto="true"
                :module="module"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-subheader class="font--primary">ZAŁĄCZNIKI Z BAZY DANYCH</v-subheader>
          </v-layout>
          <v-layout
            row
            wrap
            style="height: 90%"
          >
            <v-flex
              xs12
              style="height:100%"
            >
              <DatabaseAttachments
                :objectIdCard="oid"
                :objectTableCard="objectTable"
                :objectTypeCard="objectType"
                @attachmentAdded="loadAttachments"
              />
            </v-flex>
          </v-layout>
        </v-tab-item>
      </v-tabs>

    </div>
  </Modal>
</template>

<script>
import AddAttachment from "../../../shared/AddAttachment";
import DatabaseAttachments from "../../table/attachments/DatabaseAttachments";
import Events from "../../../shared/Events";
import Modal from "../../../shared/Modal";
import SingleObjectHistoryTable from "../../table/history/SingleObjectHistoryTable.vue"

export default {
  components: {
    AddAttachment,
    DatabaseAttachments,
    Events,
    Modal,
    SingleObjectHistoryTable
  },
  data: vm => ({
    attachmentsArr: [],
    attachmentsNumber: 0,
    dateMenu: false,
    editing: false,
    eventsNumber: 0,
    feature: undefined,
    inspectionTypeDict: [],
    isDrawing: false,
    module: 'partitions',
    objectType: "partitions",
    objectTable: "partitions",
    oid: undefined,
    prwData: {},
    prwDataCopy: {},
    statuses: [],
    watermeters: []
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    featureEvents() {
      return this.$store.getters.getFeatureEvents;
    },
    ifAttachments() {
      return this.$store.getters.getObjectAttachments;
    },
    layersInstance() {
      return this.$store.getters.getLayersInstance;
    },
    users() {
      return this.$store.getters.getUsers.map(user => {
        return {
          name: user.name,
          id: user.id
        };
      });
    }
  },
  methods: {
    addGeometry() {
      this.$root.$emit(
        "showSnackbar",
        "success",
        "Kliknij na mapie, aby narysować obszar"
      );
      this.$root.$emit("addNewArea", this.objectType);
      this.isDrawing = true;
    },
    downloadAttachment(attachmentId, attachmentName) {
      this.$refs.prwCardAttach.downloadAttachment(
        attachmentId,
        attachmentName
      );
    },
    deleteAttachment(attachmentId) {
      this.$refs.prwCardAttach.deleteAttachment(attachmentId);
    },
    loadAttachments() {
      let payload = {
        object_type: this.objectType,
        layer: this.objectTable,
        oid: this.oid
      };
      this.$store
        .dispatch("getAttachmentsForObject", payload)
        .then(success => {
          if(success) {
            this.attachmentsArr = this.$store.getters.getObjectAttachments;
          }
        });
    },
    loadData(data) {
      let payloadStatuses = {
        schema: "aquagis",
        table: "partitions",
        column: "status"
      }
      this.$store.dispatch('getDictSTC', payloadStatuses).then(r => {
        this.statuses = r.values;
      })
      this.oid = data[0].id;
      this.prwData = data[0].properties;
      this.feature = data[0];
    },
    loadWatermeters() {
      const self = this;
      let payload = {
        layername: 'watermeters',
        srid: 2180,
        with_geometry: true
      }
      this.$store.dispatch("getFeatures", payload).then(r => {
        this.watermeters = r.features.filter(el => el.properties.parent_partition == self.oid)
      });
    },
    openWatermeter() {
      this.$root.$emit(
        "showSnackbar",
        "#2a579a",
        "Trwa ładowanie karty wodomierza"
      );
      let payload = {
        layername: 'watermeters',
        srid: 2180,
        with_geometry: true
      }
      this.$store.dispatch('getFeatures', payload).then(r => {
        let watermeters = r.features;
        let payloadEvents = {
          object_id: this.oid,
          object_type: 'watermeters',
          limit: 5,
          events_count: true
        };
        let singleWatermeter = watermeters.filter(el => el.id == this.oid);
        this.$root.$emit('loadWatermeterCard', singleWatermeter);
        this.$store.dispatch("getFeatureEvents", payloadEvents).then(() => {
          this.show("watermeterCard");
        })
      })
    },
    sendId() {
      this.$root.$emit("sendId", this.oid);
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    triggerDialogAttach(val) {
      this.$emit("confDialogOpened", val);
    },
    updateList() {
      this.attachmentsNumber = this.$refs.prwCard.$refs.attachmentDropzone.getQueuedFiles().length + 1;
    },
    updateListRemove() {
      this.attachmentsNumber = this.$refs.prwCard.$refs.attachmentDropzone.getQueuedFiles().length;
    },
    zoomToGeom() {
      const layerInstance = this.layersInstance['terminals'];
      if(!layerInstance.getVisible()) {
        this.$root.$emit(
          "showSnackbar",
          "orange",
          "Włącz widoczność warstwy przyłączy"
        );
        return;
      }
      this.$root.$emit("highlightFeature", this.feature);
      this.$root.$emit("zoomToFeature", this.feature, {
        srid: this.srid
      });
    }
  },
  mounted() {
    this.$root.$on("loadPrwCard", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/watermeters/modals/PrwCard.vue